module.exports = __webpack_public_path__ + "img/no-grupo.bfeef84a.png";